export default "__VITE_ASSET__D4NI5Rd8__";